/**
 * The Layout2 Config object.
 */
const Layout2Config = {
  title: 'Horizontal',
  defaults: {
    mode: 'container',
    containerWidth: 1120,
    navbar: {
      display: true,
      style: 'fixed',
      folded: true
    },
    toolbar: {
      display: false,
      style: 'static',
      position: 'below'
    },
    leftSidePanel: {
      display: true
    },
    rightSidePanel: {
      display: true
    }
  },
  form: {
    navbar: {
      type: 'group',
      title: 'Navbar',
      children: {
        display: {
          title: 'Display',
          type: 'switch'
        }
      }
    },
    toolbar: {
      type: 'group',
      title: 'Toolbar',
      children: {
        display: {
          title: 'Display',
          type: 'switch'
        },
        position: {
          title: 'Position',
          type: 'radio',
          options: [
            {
              name: 'Above',
              value: 'above'
            },
            {
              name: 'Below',
              value: 'below'
            }
          ]
        }
      }
    }
  }
};

export type Layout2ConfigDefaultsType = (typeof Layout2Config)['defaults'];

export default Layout2Config;
